<!--
* @Author : DingHuiHui
* @Content : 我的卡包
-->
<template>
  <div class="card_wrap clearfix" id="cardBox" >
    <r-pointer :textName="`${ $t('card.title') }`">
      <div slot="btn" style="width:562px;">
        <a-input style="width:165px;" :placeholder="$t('card.tdThed[4]')" v-model="params.buyOrderNo" :allowClear="true" @pressEnter="_fetchList"/>
        <a-input style="width:265px;margin: 0 16px;" :placeholder="$t('card.tdThed[2]')" v-model="params.cardNum" :allowClear="true" @pressEnter="_fetchList"/>
        <a-select style="width:100px;" v-model="params.cardStatus" default="" @change="_fetchList">
          <a-select-option value="">{{ $t('card.status[0]') }}</a-select-option>
          <a-select-option value="unused">{{ $t('card.status[1]') }}</a-select-option>
          <a-select-option value="used">{{ $t('card.status[2]') }}</a-select-option>
          <a-select-option value="expired">{{ $t('card.status[3]') }}</a-select-option>
          <a-select-option value="invalid">{{ $t('card.status[4]') }}</a-select-option>
        </a-select>
      </div>
    </r-pointer>
    <!-- 列表 -->
    <a-row class="card_list" type="flex" justify="space-between" v-if="cardList && cardList.length">
      <a-col class="card_item" v-for="item in cardList" :key="item.cardNo">
        <!-- 兑换卡 -->
        <div :class="{c_top: true, gary: item.cardStatus !== 'unused', hight: item.cardStatus == 'unused'}" v-if="item.cardType == 1">
          <span class="btn_text">{{ getStatus(item.cardStatus) }}</span>
        </div>
        <div :class="{c_top: true, y_gary: true}" v-else></div>
        <div class="c_info">
          <a-row type="flex">
            <a-col :span="8">
              <label>{{ $t('card.tdThed[0]') }}：</label>
            </a-col>
            <a-col :span="16" class="single-line-ellipsis">
              {{ item.cardExpirateDate || '-' }}
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col :span="8">
              <label>{{ $t('card.tdThed[1]') }}：</label>
            </a-col>
            <a-col :span="16" class="single-line-ellipsis">
              {{ item.prodName || '-' }} * {{ item.prodSubMonths }}
            </a-col>
          </a-row>
          <a-row type="flex" class="card_row">
            <button class="copy_icon" v-clipboard:copy="item.cardNum" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
              <a-icon type="copy" style="color:#697b8c;"/>
            </button>
            <a-col :span="8">
              <label>{{ $t('card.tdThed[2]') }}：</label>
            </a-col>
            <a-col :span="16" class="single-line-ellipsis" :title="item.cardNum">
              {{ item.cardNum || '-' }}
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col :span="8">
              <label>{{ $t('card.tdThed[4]') }}：</label>
            </a-col>
            <a-col :span="16" class="single-line-ellipsis" :title="item.buyOrderNo">
              {{ item.buyOrderNo || '-' }}
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col :span="8">
              <label>{{ $t('card.tdThed[3]') }}：</label>
            </a-col>
            <a-col :span="16" class="single-line-ellipsis" :title="item.buyTime">
              {{ item.buyTime || '-' }}
            </a-col>
          </a-row>
          <div v-if="item.cardStatus == 'unused'" >
            <div class="again disUse" v-if="item.second > 0"><span v-if="item.second < intervalSecond">{{ $t('card.time', { s: item.second}) }}</span>{{ $t('card.again') }} </div>
            <div class="again" @click="getOptions(item)" v-else>{{ $t('card.again') }}</div>
          </div>
          <div class="again disUse" v-else>{{ $t('card.again') }}</div>
        </div>
      </a-col>
      <a-col v-if="cardList.length % column <= 0" style="display:none"></a-col>
      <a-col class="card_item empty" v-for="item in (column - cardList.length % column)" :key="item" v-else></a-col>
    </a-row>
    <div v-else class="ant-list-empty-text">{{ $t('noData') }}</div>
  </div>
</template>

<script>
import { apiCard } from '@/api/ECard'
import { mapGetters } from 'vuex'
// import { cookie } from '@/utils/util'

export default {
  data () {
    return {
      RefreshTimer: null,
      column: 4, // 列表的列数
      params: {
        custNo: '',
        cardStatus: '', // 卡状态 unused:未使用used:已使用expired:已过期invalid:已作废
        buyOrderNo: '',
        cardNum: '' // 卡号
      },
      cardList: [],
      // 重新获取接口loading
      isLoading: false,
      // 45秒后才能再次获取
      intervalSecond: 45
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.params.custNo = JSON.parse(this.userInfo).custNo
    this._fetchList()
  },
  mounted () {
    this.$nextTick(() => {
      this._InitCardColumn()
      window.onresize = () => {
        this._InitCardColumn()
      }
    })
  },
  methods: {
    /**
     * 计算一行显示多少个卡
     */
    _InitCardColumn () {
      // 列表容器宽度
      const ElemWidth = document.getElementById('cardBox').clientWidth - 48
      this.column = Math.floor(ElemWidth / 268)
      console.log(this.column)
    },
    /**
     * 获取兑换卡列表
     */
    _fetchList () {
      // this.cardList = []
      apiCard.list(this.params).then(data => {
        console.log(data)
        this.cardList = data || []
        this.cardList.forEach(obj => {
          this.$set(obj, 'second', 0)
        })
      })
    },
    /**
     * 复制到剪贴板-成功
     */
    copySuccess (e) {
      // console.log('You just copied: ' + e.text)
      this.$message.success(this.$t('robotDes.copyOK'))
    },
    /**
     * 复制到剪贴板-失败
     */
    copyError (e) {
      this.$message.error(this.$t('robotDes.copyError'))
    },
    /**
     * 卡状态
     */
    getStatus (state) {
      switch (state) {
        case 'unused':
          return this.$t('card.status[1]')
        case 'used':
          return this.$t('card.status[2]')
        case 'expired':
          return this.$t('card.status[3]')
        case 'invalid':
          return this.$t('card.status[4]')
        default:
          return this.$t('card.status[0]')
      }
    },
    /**
     * 重新获取
     */
    getOptions (record) {
      let interTime = this.intervalSecond
      this.$set(record, 'second', interTime)
      const _this = this
      let cardTimer = null
      apiCard.reget(record.cardNo).then(data => {
        // 倒计时
        cardTimer = setInterval(() => {
          if (interTime <= 0) {
            clearInterval(cardTimer)
          }
          this.$set(record, 'second', interTime--)
        }, 1000)
        this.$success({
          title: _this.$t('operation.tip'),
          content: _this.$t('card.msg', { pwd: data })
        })
      }).catch(() => {
        this.$set(record, 'second', 0)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card_wrap {
  background: #fff;
  padding: 0 24px 40px;
  // min-width: 1200px;
  .card_list {
    .card_item {
      width: 268px;
      height: 250px;
      margin-top: 30px;
      position: relative;
      overflow: hidden;
      .c_top {
        border-radius:8px;
        width: 90%;
        // margin: 0 auto;
        height: 164px;
        padding: 15px 20px;
        color: #CFA972;
        text-align: right;
        position: absolute;
        top: 0px;
        left: 50%;
        margin-left: -45%;
        .btn_text {
          border: 1px solid #CFA972;
          border-radius: 15px;
          padding: 0px 9px;
        }
        &.gary {
          background: url('../../assets/images/card_gray.png') no-repeat;
          .btn_text {
            border-color: #A2A2A2;
            color: #A2A2A2;
          }
        }
        &.hight {
          background: url('../../assets/images/purchase/card_bg.png') no-repeat;
        }
        &.y_gary {
          background: url('../../assets/images/y_gold.png') no-repeat;
        }
      }
      .c_info {
        box-shadow:0px 0px 10px 0px rgba(221,221,221,1);
        background: url('../../assets/images/card_white.png') no-repeat;
        padding: 15px 18px;
        width: 248px;
        position: absolute;
        left: 10px;
        bottom: 6px;
        z-index: 2;
        line-height: 25px;
        label {
          // width: 75px;
          display: inline-block;
          color: #999;
        }
        .again {
          text-align: center;
          color: #4977FC;
          margin-top: 12px;
          cursor: pointer;
          button {
            border-color: #fff;
          }
          &.disUse {
            cursor: not-allowed;
            color: #999;
          }
        }
        .card_row {
          position: relative;
          .copy_icon {
            position: absolute;
            right: -14px;
            top: 6px;
            i {
              color: #4977FC !important;
            }
          }
        }
      }
    }
  }
  .empty {
    margin-top: 0 !important;
  }
}
</style>
